<template>
  <span class="input-append">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "InputAppend",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.input-append {
  margin-left: 10px;
  margin-right: 10px;
  &.-xs {
    font-size: 10px;
  }
  &.-radio {
    font-size: 14px;
    margin: 0;
  }
}
</style>
